import { useState } from 'react';
import { useSnackbar } from 'notistack';
// @mui
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Stack,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
// hooks
import useAuth from '../../../hooks/useAuth';
// components
import Iconify from '../../../components/Iconify';
import DIOText from '../../../components/DIOText';
// utils
import axios from '../../../utils/axios';
import { fKrSendKST } from '../../../utils/formatTime';

// ----------------------------------------------------------------------

export default function ExtendDeadlineDialog({ 
  isOpen,
  closeDialog,
  reloadOffer,
  currentDeadline,
  jobPost,
  candidate,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();
  const [reason, setReason] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const newDeadline = new Date(currentDeadline);
  newDeadline.setDate(newDeadline.getDate() + 7);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      const companyId = user?.employee.company[0].id;
      const jobPostId = jobPost?.id;
      const candidateId = candidate?.id;
      await axios.post(`/api/company/${companyId}/job-posts/${jobPostId}/candidate/${candidateId}/crew-negotiate-extend/`, {
        reason,
      });
      enqueueSnackbar('기한이 연장되었습니다');
      reloadOffer();
      closeDialog();
    } catch (error) {
      console.error(error);
      enqueueSnackbar('기한 연장에 실패했습니다. 다시 시도해주세요.', { variant: 'error' });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog
      open={isOpen}
      fullWidth
      maxWidth="dg"
    >
      <DialogContent>
        <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
          <Iconify icon={"eva:alert-triangle-fill"} sx={{ width: 20, height: 20, color: 'error.main' }} />
          <Typography variant="subtitle2" sx={{ color: "error.main" }}>
            잠깐, 꼭 확인해주세요
          </Typography>
        </Stack>
        <Typography variant={"h6"} gutterBottom>
          기한 연장은 단 한번만 가능합니다.
        </Typography>
        <Typography variant="body1" sx={{ wordBreak: "break-all" }} paragraph>
          연장 시 기한은 7일 후인 <b>{fKrSendKST(newDeadline)}</b>로 변경됩니다.
          기한 연장 사유는 <DIOText />에게만 공유됩니다.
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder="연장 사유를 적어주세요."
        />
      </DialogContent>
      <DialogActions>
        <Stack spacing={2} direction="row" sx={{ width: '100%', pb: 2 }}>
          <LoadingButton
            onClick={closeDialog}
            loading={isSubmitting}
            size="large"
            fullWidth
          >
            취소
          </LoadingButton>
          <LoadingButton
            onClick={handleSubmit}
            variant="contained"
            loading={isSubmitting}
            size="large"
            fullWidth
            disabled={!reason.trim()}
          >
            기한 연장하기
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  );
} 